/**
 * setPropertyParentSchema — SCRUM-331 step 2 (tdd-runner).
 *
 * HTTP-boundary Zod schema for PATCH .../properties/:id/parent request body.
 * Validates the single-field payload that sets or clears a unit's parent link.
 *
 * `parentPropertyId` is the UUID of the proposed parent Unit, or `null` to
 * CLEAR the existing link. Both operations are handled by the same endpoint
 * (one verb, two semantics) to mirror SetParentUnitUseCase's single `execute`
 * branch.
 *
 * ID validation: `z.string().uuid()` — mirrors the pattern used in the
 * existing property schemas (reservation-preview.schema.ts, amenity.ts, and the
 * ownership schemas) and in open-ownership.schema.ts. Zod's uuid() validator is
 * sufficient here: the use case enforces org-scoping + existence via the
 * IPropertyTreeReadRepository lock (EntityNotFoundError → 404 at the interface
 * layer) — there is no need for the stricter STRICT_UUID regex that guards the
 * amenity catalog FK (where a malformed version nibble would silently pass the
 * catalog lookup). A malformed UUID fails Zod validation → 400 (correct).
 *
 * `.nullable()` is applied directly on the field (not `.optional()`): `null`
 * is the explicit "CLEAR" signal; omitting the field entirely is a malformed
 * body and must be rejected with 400.
 */
import { z } from 'zod';
export const setPropertyParentSchema = z.object({
    /** UUID of the parent property, or `null` to clear the link. */
    parentPropertyId: z.string().uuid().nullable(),
});
//# sourceMappingURL=set-property-parent.schema.js.map